module.exports = __webpack_public_path__ + "/a00781f7a3c558d13989387f95b96c4f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/assets/logos/twitter_logo_@2x.png
 ** module id = 956
 ** module chunks = 0
 **/